<template>
  <div>
    <label class="group_managementTree">
      <div class="group_managementTree_group">
        <input
          type="checkbox"
          v-model="treeData.checkAll"
          @click.self="checkedAll"
          class="group_managementTree_input"
        />
        <span class="group_managementTree_span"
          >{{ treeData.name }}（{{ treeData.account_list.length }}）</span
        >
        <img
          :src="unchecked"
          alt="下拉"
          class="group_managementTree_img"
          v-show="showSubdirectories == 1"
          @click="treeGroup()"
        />
      </div>
      <div
        class="group_managementTree_content"
        :class="checkIndex % 2 == 0 ? 'active_height_0' : 'active_height_auto'"
      >
      <!-- 误删 -->
        <span
          v-for="(list, index) in treeData.account_list"
          :key="index"
          v-show="showSubdirectories == 1"
          class="group_managementTree_list"
        >
          <input
            type="checkbox"
            v-model="list.checked"
            @click.stop="checkedSome(list)"
          />
          <img :src="list.avatar" alt="list.wx_name" />
          <span v-if="list.wx_name">{{ list.wx_name }}</span>
          <span v-else-if="list.name">{{ list.name }}</span>
          <span v-else>{{ list.mp_name }}</span>
        </span>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: "treePopup",
  data() {
    return {
      unchecked: require("@/common/assets/unchecked.png"),
      checkAll: false,
      checkAllList: [],
      getCheckList: {},
      deteleGroup: [],
      checkIndex: 0,
    };
  },
  watch: {
    checkAllList(data) {
      if (this.treeData.account_list.length == data.length) {
        // console.log(data);
        this.treeData.checkAll = true;
      } else {
        this.treeData.checkAll = false;
      }
    },
  },
  methods: {
    treeGroup() {
      this.checkIndex++;
      //   console.log(this.checkIndex);
    },
    checkedAll() {
      //  选中时候添加到数组里
      //   console.log(this.treeData.checkAll);
      if (!this.treeData.checkAll) {
        this.treeData.account_list.forEach((item) => {
          item.checked = true;
          // 将选择的公众号添加到 checkAllList 数组里
          if (this.checkAllList.indexOf(item) == -1) {
            this.checkAllList.push(item);
            // console.log(item, this.treeData);
          }
        });
        this.$emit(
          "treeGetData",
          (this.getCheckList = {
            treeData: this.treeData,
            checkAllList: this.checkAllList,
          })
        );
      } else {
        this.treeData.account_list.forEach((item) => {
          item.checked = false;
        });
        this.checkAllList = [];
        this.$emit(
          "treeGetData",
          (this.getCheckList = {
            treeData: null,
            checkAllList: this.checkAllList,
          })
        );
      }
    },
    checkedSome(item) {
      if (!item.checked) {
        //   选中时候添加单个参数
        if (this.checkAllList.indexOf(item) == -1) {
          this.checkAllList.push(item);
        }
        this.$emit(
          "treeGetData",
          (this.getCheckList = {
            treeData: this.treeData,
            checkAllList: this.checkAllList,
          })
        );
      } else {
        this.checkAllList.splice(this.checkAllList.indexOf(item), 1);
        this.$emit(
          "treeGetData",
          (this.getCheckList = {
            treeData: null,
            checkAllList: this.checkAllList,
          })
        );
      }
    },
  },
  props: {
    treeData: {
      type: Object,
      default: () => {},
    },
    showSubdirectories: {
      type: Number,
      default: 1,
    }
  },
};
</script>

<style lang="less" scoped>
.active_height_auto {
  display: inline-block;
  min-height: 0px;
  transition: 1s;
}
.active_height_0 {
  display: inline-block;
  height: 0px;
  transition: 1s;
}
.group_managementTree {
  //   border: solid 1px;
  display: inline-block;
  width: 100%;
  box-sizing: border-box;
  .group_managementTree_group {
    // border: solid 1px;
    padding: 0 20px;
    height: 50px;
    display: inline-block;
    width: 100%;
    box-sizing: border-box;
    .group_managementTree_input {
      width: 20px;
      height: 20px;
      display: inline-block;
      float: left;
      margin-top: 12px;
    }
    .group_managementTree_span {
      font-size: 20px;
      line-height: 50px;
      float: left;
      font-weight: 600;
      margin-left: 10px;
    }
    .group_managementTree_img {
      float: right;
      margin-top: 18px;
      width: 16px;
      height: 10px;
      display: inline-block;
    }
  }
  .group_managementTree_content {
    width: 100%;
    display: inline-block;
    // border: solid 1px red;
    box-sizing: border-box;
    padding: 0 40px;
    // height: 0px;
    overflow: hidden;
    .group_managementTree_list {
      width: 100%;
      display: inline-block;
      //   border: solid 1px green;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      box-sizing: border-box;
      //   height: 60px;
      input:first-child {
        width: 20px;
        height: 20px;
        display: inline-block;
        float: left;
        margin-top: 18px;
      }
      img:nth-child(2) {
        display: inline-block;
        width: 40px;
        height: 40px;
        border-radius: 100%;
        border: solid 1px #ccc;
        float: left;
        margin-top: calc(50px / 2 - 42px / 2);
        margin-left: 10px;
      }
      span:nth-child(3) {
        font-size: 20px;
        line-height: 60px;
        float: left;
        margin-left: 10px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/searchPopup/tree-popup.vue